import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificacionesService } from './notificaciones.service';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.scss']
})
export class NotificacionesComponent implements OnInit {

	public filtersAllowed: {} = {
		searching: ['Todos', 'No Leidos'],
		orderBy: ['Fecha', 'Asunto']
	};
	public filtro:any;
	
	public notificaciones:any[];
	public notificacionSeleccionada:any;

	private paginaAnterior: number = 1;
	private paginaActual: number = 1;
	private totalPaginas: number = 1;
	
	public puedeIrAPaginaAnterior: boolean = false;
	public puedeIrAPaginaSiguiente: boolean = false;
	private onNotificationsChange: Subject<any>;

	constructor(
		private _notificacionesService: NotificacionesService
	) { }

	ngOnInit(): void {
		this.inicializarFiltrosDeBusqueda();
		this.notificaciones = [];
		this.onNotificationsChange = new Subject();
		
		this.onNotificationsChange.subscribe(data => {
			this.totalPaginas = data.paging.totalPages;

			this.puedeIrAPaginaAnterior = this.paginaActual > 1;
			this.puedeIrAPaginaSiguiente = this.paginaActual < this.totalPaginas;
		});

		this.realizarBusqueda();
	}

	public visualizarNotificacion(notificacion:any): void {
		if(notificacion.leido){
			this.notificacionSeleccionada = notificacion;
			return;
		}
		this._notificacionesService.update(notificacion)
		.subscribe(response => {
			if(!response.result) return;
			notificacion.leido = true;
			this.notificacionSeleccionada = notificacion;
			this._notificacionesService.onNotificationChanged.next(true);
		})
	}

	public notificationPrevPage(): void {
		if(!this.puedeIrAPaginaAnterior) return;
		this.paginaAnterior = this.paginaActual;
		this.paginaActual--;
		this.realizarBusqueda(false);
	}
	public notificationNextPage(): void {
		if (!this.puedeIrAPaginaSiguiente) return;
		this.paginaAnterior = this.paginaActual;
		this.paginaActual++;
		this.realizarBusqueda(false);
	}

	public realizarBusqueda(resetActualPage:boolean = true):void {
		if (resetActualPage){
			this.paginaActual = 1;
		}
		this._notificacionesService.getNotificaciones(this.paginaActual, this.filtro)
		.subscribe(response => {
			if(!response.result) {
				this.paginaActual = this.paginaAnterior;
				return;
			}
			this.notificaciones = response.data.items;
			this.onNotificationsChange.next(response.data);
		})
	}

	public limpiarFiltros(): void {
		this.paginaActual = 1;
		this.paginaAnterior = this.paginaActual;
		this.totalPaginas = this.paginaActual;
		this.inicializarFiltrosDeBusqueda();
		this.realizarBusqueda();
	}

	private inicializarFiltrosDeBusqueda(): void {
		this.filtro = {
			buscarPor: 'Todos', 
			ordenarPor: 'Fecha',
			texto: undefined
		};
	}
}
